var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.isDark || _vm.hasDark}},[_c('toolbar'),_c('drawer'),_c('savedialog'),_c('opendialog'),_c('compiledialog'),_c('notedialog'),_c('v-content',{style:(_vm.getBGStyle())},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }